<template>
  <div class="search-result-card" @click="clickSearchResultCard">
    <div class="category-icon-container">
      <img class="category-icon" :src="categoryIconPath !== '' ? categoryIconPath : util.getImagePath('pin_blue@2x.png')" :srcset="categoryIconHdPath !== '' ? `${categoryIconHdPath} 2x` : util.getImageSet('pin_blue')">
      <img class="fav-icon" :src="util.getImagePath('star_orange@2x.png')" :srcset="util.getImageSet('star_orange')" v-if="isFav">
    </div>
    <div class="detail">
      <div class="name">{{ $i18n.locale === 'th' ? nameTh : nameEn }}</div>
      <!-- <div class="code" v-html="displayCode"></div> -->
      <PromptPaiSnippetButton :id="code" v-if="code.length === 8" />
      <div class="address">{{ ($i18n.locale === 'th' ? addressTh : addressEn).replace(/undefined/g, '') }}</div>
    </div>
    <div class="right-detail">
      <button ref="promptpaiIconButton" class="promptpai-icon-button" @click="clickPromptpaiIcon" v-if="code.length === 8 && !isHidePromptpaiIcon">
        <img :src="util.getImagePath('arrow_up_blue@2x.png')" :srcset="util.getImageSet('arrow_up_blue')">
      </button>
    </div>
  </div>
</template>

<script>
import PromptPaiSnippetButton from '@/components/PromptPaiSnippetButton.vue'

export default {
  name: 'SearchResultCard',
  components: {
    PromptPaiSnippetButton
  },
  props: {
    categoryIconPath: {
      type: String,
      default: ''
    },
    categoryIconHdPath: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    nameTh: {
      type: String,
      default: ''
    },
    nameEn: {
      type: String,
      default: ''
    },
    addressTh: {
      type: String,
      default: ''
    },
    addressEn: {
      type: String,
      default: ''
    },
    isFav: {
      type: Boolean,
      default: false
    },
    isHidePromptpaiIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayCode () {
      var self = this
      if (self.code.length === 8) {
        return self.code.substring(0, 4) + ' ' + self.code.substring(4, 8)
      } else {
        return ''
      }
    }
  },
  methods: {
    clickSearchResultCard (e) {
      var self = this
      var isPromptpaiIconButton = self.code.length === 8 ? self.$refs['promptpaiIconButton'] === e.target || self.$refs['promptpaiIconButton'].contains(e.target) : false
      if (!isPromptpaiIconButton) {
        self.$emit('clickSearchResultCard')
      }
    },
    clickPromptpaiIcon () {
      var self = this
      self.$emit('clickPromptpaiIcon')
    }
  }
}
</script>

<style scoped>
  .search-result-card {
    width: 100%;
    /* height: 60px; */
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  .search-result-card.clickable:hover {
    background: rgb(227, 227, 227);
  }

  .category-icon-container {
    width: 24px;
    height: 24px;
    margin: auto 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  img.category-icon {
    max-width: 24px;
    max-height: 24px;
  }

  .fav-icon {
    position: absolute;
    width: 16px;
    height: 16px;
    /* margin: 2px 0px auto 6px; */
    top: 16px;
    left: 16px;
  }

  .detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: calc(100% - 56px - 60px);
    /* overflow: hidden; */
    /* padding-top: 4px; */
    box-sizing: border-box;
    align-self: center;
  }

  .detail > .name {
    font-size: 16px;
    font-weight: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.75;
    text-align: left;
    text-indent: 2px;
  }

  .detail > .code {
    font-size: 18px;
    color: rgb(120, 120, 120);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1;
    text-align: left;
  }

  .detail > .address {
    color: rgb(120, 120, 120);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    line-height: 1.75;
    text-align: left;
    margin-top: 4px;
  }

  .right-detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: center;
    width: 60px;
    overflow: hidden;
    box-sizing: border-box;
  }

  button.promptpai-icon-button {
    width: 32px;
    height: 32px;
    padding: 0px;
    margin: 6px 12px 0px 16px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    overflow: hidden;
    transform: rotate(90deg);
  }

  .promptpai.icon > img {
    width: 32px;
    height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchResultCard.vue